import React, { useEffect, useRef } from 'react';
import { Box } from '@mui/material';
import PricingCards from './PricingCards';
import Logo from '../common/Logo';
import { Container } from '@mui/system';
import PricingFAQ from '../../../landingPage/components/PricingFAQ';
import { useSignup } from '../../context/SignupContext';
import userClient from '../../../utils/apiClients/userClient';
import { setActiveProfile } from '../../context/AppContext';

const ChoosePlan: React.FC = () => {
  const { account } = useSignup();
  const hasCalledCreatorOnboarding = useRef(false);

  // Call onboarding API when creator enters this step (first step after profile selection)
  useEffect(() => {
    const callCreatorOnboarding = async () => {
      if (account.userType === 'creator' && account.accountType && !hasCalledCreatorOnboarding.current) {
        hasCalledCreatorOnboarding.current = true;
        try {
          await userClient.put('/users/me/creator-profile', {
            accountType: 'personal'
          });
          // Set active profile to creator after successful API call
          setActiveProfile('creator');
        } catch (error) {
          console.error('Error during creator onboarding:', error);
        }
      }
    };
    callCreatorOnboarding();
  }, [account.userType, account.accountType]);

  return (
    <Container
      disableGutters
      maxWidth="xl"
      sx={{
        padding: { xs: 2, sm: 4, md: 6, lg: 1 },
        marginTop: { xs: 2, sm: 1, md: 0 },
        minHeight: '100vh',
      }}
    >
      <Box sx={{
        pl: {
          xs: 2,
          sm: 4,
          md: 6,
          lg: 13,
        },
        pt: {
          xs: 2,
          sm: 4,
          md: 6,
          lg: 4,
        },
      }}>
        <Logo />
      </Box>


      <Box sx={{ mt: '4px' }}>
        <div className=" ">
          <PricingCards />
        </div>
        <div className="max-w-[81rem] mx-auto pt-20 px-4 md:pt-[0px] md:mb-20 lg:px-24">
          <h2 className="text-2xl font-inter font-bold mb-10 text-center md:text-[41.8px] md:mt-[7rem]">Pricing FAQ</h2>
          <PricingFAQ />
        </div>

      </Box>

    </Container >
  );
};

export default ChoosePlan;


